import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Formik, Form, Field } from 'formik'
import { TextField, FormControlLabel, Checkbox } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { object, string } from 'yup'
import { User } from '../../../../interfaces/User/UserWMS'
import { putUserWMS } from '../api'

export interface UserEditHandle {
  submitForm: () => void
}

interface UserEditProps {
  user: User
  onSuccess: (message: string) => void
  onError: (message: string) => void
}

const validationSchema = object({
  userAlias: string()
    .trim()
    .required('Debe ingresar un nombre.')
    .max(80, 'Puede componerse por un máximo de 80 caracteres')
})

export const UserEditModal = forwardRef<UserEditHandle, UserEditProps>(
  ({ user, onSuccess, onError }, ref) => {
    const formikRef = useRef<any>(null)

    useImperativeHandle(ref, () => ({
      submitForm: () => formikRef.current?.submitForm()
    }))

    const handleSubmit = (values: User) => {
      putUserWMS(values)
        .then(() => onSuccess('Usuario actualizado correctamente'))
        .catch(({ response }) =>
          onError(response?.data?.message || 'Hubo un error al intentar actualizar el usuario.')
        )
    }

    return (
      <Formik
        innerRef={formikRef}
        initialValues={user}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid size={12}>
                <TextField
                  name='userName'
                  label='Email'
                  fullWidth
                  variant='outlined'
                  value={values.userName}
                  disabled
                />
              </Grid>

              <Grid size={12}>
                <Field
                  as={TextField}
                  name='userAlias'
                  label='Nombre'
                  fullWidth
                  variant='outlined'
                  value={values.userAlias}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.userAlias && Boolean(errors.userAlias)}
                  helperText={touched.userAlias && errors.userAlias}
                  disabled={isSubmitting}
                  required
                />
              </Grid>

              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Field
                      as={Checkbox}
                      name='active'
                      checked={values.active}
                      onChange={handleChange}
                      color='primary'
                      disabled={isSubmitting}
                    />
                  }
                  label='Activo'
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    )
  }
)
